import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const ListGroupItem = ({
  element,
  containerElement,
  containerClassName,
  children,
  className,
  active,
  activeType,
  innerRef,
  ...rest
}) => {
  const ContainerElement = containerElement
  const Element = element

  const containerProps =
    ContainerElement !== Fragment
      ? {
          className: containerClassName,
        }
      : {}

  return (
    <ContainerElement {...containerProps}>
      <Element
        {...rest}
        className={classnames(
          'ln-c-list-group__item',
          active && 'is-active',
          className,
        )}
        aria-current={active && !!activeType ? activeType : undefined}
        ref={innerRef}
      >
        {children}
      </Element>
    </ContainerElement>
  )
}

ListGroupItem.propTypes = {
  /** Allows the top-level element to be customized */
  element: PropTypes.elementType,
  /** Element that will wrap the item */
  containerElement: PropTypes.elementType,
  /** ClassName to add to the wrapping `li` if not overriden by `containerElement` */
  containerClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  /** Should the item be highlighted within the list */
  active: PropTypes.bool,
  /** Additional context for screen readers - what does the active item relate to */
  activeType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  innerRef: PropTypes.func,
}

ListGroupItem.defaultProps = {
  element: 'span',
  containerElement: 'li',
  containerClassName: undefined,
  children: undefined,
  className: undefined,
  active: false,
  activeType: 'page',
  innerRef: undefined,
}

ListGroupItem.displayName = 'ListGroupItem'

export default ListGroupItem
